const areaNames = {
  Alabama: [13820, 19460, 26620, 33660, 33860],
  Alaska: [],
  Arizona: [38060, 46060],
  Arkansas: [22220, 32820, 30780],
  California: [23420, 31084, 40140, 40900, 41740, 41860, 41940],
  Colorado: [14500, 17820, 19740, 22660],
  Connecticut: [14860, 25540, 35300, 35980, 49340],
  Delaware: [20100, 37980],
  Florida: [
    15980,
    18880,
    19660,
    23540,
    27260,
    29460,
    33100,
    34940,
    35840,
    36100,
    36740,
    37340,
    37460,
    37860,
    38940,
    39460,
    42680,
    45220,
    45300
  ],
  Georgia: [12060, 16860],
  Hawaii: [46520],
  Idaho: [14260],
  Illinois: [19340, 14010, 16580, 19500, 28100, 37900, 40420, 44100, 16980, 41180],
  Indiana: [16980, 23060, 26900, 43780, 31140, 17140],
  Iowa: [16300, 19780, 47940, 19340, 36540],
  Kansas: [45820, 48620, 28140],
  Kentucky: [14540, 30460, 31140, 17140],
  Louisiana: [12940, 35380, 43340],
  Maine: [38860],
  Maryland: [47900, 12580, 19060, 25180, 37980],
  Massachusetts: [12700, 38340, 44140, 49340, 14460, 39300],
  Michigan: [43780, 11460, 19820, 24340, 29620],
  Minnesota: [33460, 22020],
  Mississippi: [25060, 27140, 32820],
  Missouri: [22220, 17860, 44180, 41180, 28140],
  Montana: [],
  Nebraska: [30700, 36540],
  Nevada: [29820, 39900],
  'New Hampshire': [14460, 31700],
  'New Jersey': [12100, 45940, 35620, 10900, 37980],
  'New Mexico': [10740, 22140],
  'New York': [10580, 15380, 21300, 24020, 28740, 40380, 45060, 35620],
  'North Carolina': [20500, 22180, 24660, 39580, 48900, 49180, 16740, 34820, 47260],
  'North Dakota': [13900, 22020],
  Ohio: [10420, 15940, 17460, 18140, 45780, 17140, 49660],
  Oklahoma: [36420, 46140],
  Oregon: [21660, 41420, 38900],
  Pennsylvania: [35620, 49660, 21500, 25420, 39740, 49620, 10900, 37980],
  'Rhode Island': [39300],
  'South Carolina': [16740, 16700, 17900, 22500, 24860, 43900, 34820],
  'South Dakota': [43620],
  Tennessee: [16860, 28940, 34980, 32820],
  Texas: [10180, 11100, 12420, 13140, 18580, 19100, 21340, 26420, 41700, 48660],
  Utah: [36260, 41620],
  Vermont: [15540],
  Virginia: [47900, 40060, 47260],
  Washington: [38900, 47900, 28420, 42660, 44060, 49420],
  'West Virginia': [47900, 19060, 25180, 16620],
  Wisconsin: [33460, 16980, 11540, 22540, 24580, 31540, 33340, 36780],
  Wyoming: []
};

export default areaNames;
